import { Component, Vue } from 'vue-property-decorator';
import Time from '../../assets/interfaces/Time';

@Component
export default class TempoController extends Vue {
    // DATA
    private tempo: Time = {
        data: {dia: '', mes: '', ano: ''},
        relogio: {hora: '', minutos: '', segundos: ''},
    };

    private tempoDate: Date;

    //  LIFECYCLE
    public created() {
        this.setTempo();
    }

    // METHODS
    public updateTempo() {
        this.tempoDate = new Date();
        const hora =
            this.tempoDate.getHours() < 10 ? '0' + this.tempoDate.getHours() : this.tempoDate.getHours();
        const minuto =
            this.tempoDate.getMinutes() < 10 ? '0' + this.tempoDate.getMinutes() : this.tempoDate.getMinutes();
        const segundo =
            this.tempoDate.getSeconds() < 10 ? '0' + this.tempoDate.getSeconds() : this.tempoDate.getSeconds();
        const dia = this.tempoDate.getDate() < 10 ? '0' + this.tempoDate.getDate()  : this.tempoDate.getDate();
        const mes =
            this.tempoDate.getMonth() + 1 < 10
                ? '0' + (this.tempoDate.getMonth() + 1)
                : this.tempoDate.getMonth() + 1;
        const ano = this.tempoDate.getFullYear();
        this.tempo.relogio.hora = String(hora);
        this.tempo.relogio.minutos = String(minuto);
        this.tempo.relogio.segundos = String(segundo);
        this.tempo.data.dia = String(dia);
        this.tempo.data.mes = String(mes);
        this.tempo.data.ano = String(ano);
    }

    public setTempo() {
        this.updateTempo();
        setInterval(this.updateTempo, 100);
    }

    public getTempo(): Time {
        return this.tempo;
    }

    public getData(): string {
        return `${this.tempo.data.dia}/${this.tempo.data.mes}/${this.tempo.data.ano}`;
    }

    public getHoraCompleta(): string {
        return `${this.tempo.relogio.hora}:${this.tempo.relogio.minutos}:${this.tempo.relogio.segundos}`;
    }

    public getHora(): string {
        return `${this.tempo.relogio.hora}:${this.tempo.relogio.minutos}`;
    }

    public getGMTTimezone(): string {
        return this.tempoDate.toString().match(/([A-Z]+[\+-][0-9]+.*)/)[1];
    }

}
